import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "@/assets/style/tailwindcss.css";
import "ant-design-vue/dist/antd.css";
import Antd from "ant-design-vue";
import request from "@/utils/http";
import promiseFlat from "@/utils/promiseFlat";
import table from "@/components/table/index.vue";
import operationButtons from "@/components/operationButtons/index.vue";
import switchWithNumber from "@/components/switchWithNumber/index.vue";
import teleport from "@/components/teleport/index.vue";
import { message } from "ant-design-vue";
import "@/router/guard.js";

Vue.prototype.$promiseFlat = promiseFlat;
Vue.prototype.$request = request;
Vue.prototype.$msg = message;
Vue.config.productionTip = false;
Vue.use(Antd);
Vue.component(table.name, table);
Vue.component(operationButtons.name, operationButtons);
Vue.component(switchWithNumber.name, switchWithNumber);
Vue.component(teleport.name, teleport);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
